import { createAction, props } from '@ngrx/store';
import { ICondicionalRelease } from "src/app/shared/interfaces/condicional/icondicional.release";
import { ICondicionalTrigger } from 'src/app/shared/interfaces/condicional/icondicional.trigger';

enum CondicionalActionType {

    LOAD_RELEASE = '[condicional] load release from api',
    LOAD_RELEASE_SUCCESS = '[condicional] load release from api return success',

    EDIT_RELEASE = '[condicional] edit release from api',
    EDIT_RELEASE_SUCCESS = '[condicional] edit release from api return success',

    LOAD_TRIGGER = '[condicional] load trigger from api',
    LOAD_TRIGGER_SUCCESS = '[condicional] load trigger from api return success',

    EDIT_TRIGGER = '[condicional] edit trigger from api',
    EDIT_TRIGGER_SUCCESS = '[condicional] edit trigger from api return success',


}

const loadRelease = createAction(
    CondicionalActionType.LOAD_RELEASE, props<{ id: number }>()
);

const loadReleaseSuccess = createAction(
    CondicionalActionType.LOAD_RELEASE_SUCCESS, props<{ release: ICondicionalRelease }>()
);

const loadTrigger = createAction(
    CondicionalActionType.LOAD_TRIGGER, props<{ id: number }>()
);

const loadTriggerSuccess = createAction(
    CondicionalActionType.LOAD_TRIGGER_SUCCESS, props<{ trigger: ICondicionalTrigger }>()
);

const editRelease = createAction(
    CondicionalActionType.EDIT_RELEASE,
    props<{ release: ICondicionalRelease; id: number }>()
);

const editTrigger = createAction(
    CondicionalActionType.EDIT_TRIGGER,
    props<{ trigger: ICondicionalTrigger; id: number }>()
);

export const ConditionalActions = {
    loadRelease,
    loadReleaseSuccess,
    loadTrigger,
    loadTriggerSuccess,
    editRelease,
    editTrigger
}